
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-employers/pricing",
      function () {
        return require("private-next-pages/for-employers/pricing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-employers/pricing"])
      });
    }
  